import React from "react";
import { Helmet } from "react-helmet-async";
import { SiteHeader } from "../components/layout/SiteHeader";
import { HeroSection } from "../components/sections/HeroSection";
import { CapabilitiesSection } from "../components/sections/CapabilitiesSection";
import { HowItWorksSection } from "../components/sections/HowItWorksSection";
import { FinalCtaSection } from "../components/sections/FinalCtaSection";
import { SiteFooter } from "../components/layout/SiteFooter";

export function HomePage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-dark">
      <Helmet>
        <title>Feuteuristix — Container Load Planning Intelligence</title>
        <meta name="description" content="Find the cheapest container combination and the tightest packing plan for your cargo — in one click. Used by Fortune 500 logistics and supply chain teams worldwide." />
        <meta property="og:title" content="Feuteuristix — Container Load Planning Intelligence" />
        <meta property="og:description" content="Find the cheapest container combination and the tightest packing plan for your cargo — in one click. Used by Fortune 500 supply chain teams worldwide." />
        <meta property="og:url" content="https://feuteuristix.com/" />
        <link rel="canonical" href="https://feuteuristix.com/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "@id": "https://feuteuristix.com/#organization",
              "name": "Feuteuristix",
              "url": "https://feuteuristix.com",
              "logo": "https://feuteuristix.com/og-image.png",
              "description": "Container load planning intelligence — finds the cheapest container combination and optimal 3D packing plan for any cargo.",
              "contactPoint": { "@type": "ContactPoint", "email": "contact@feuteuristix.com", "contactType": "sales" }
            },
            {
              "@type": "WebSite",
              "@id": "https://feuteuristix.com/#website",
              "url": "https://feuteuristix.com",
              "name": "Feuteuristix",
              "publisher": { "@id": "https://feuteuristix.com/#organization" }
            },
            {
              "@type": "SoftwareApplication",
              "name": "Feuteuristix Container Load Planner",
              "applicationCategory": "BusinessApplication",
              "operatingSystem": "Web",
              "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
              "description": "Compute the cheapest container mix and optimal 3D packing plan for your cargo in one click."
            }
          ]
        })}</script>
      </Helmet>
      <SiteHeader />
      <main className="flex flex-1 flex-col">
        <HeroSection />
        <CapabilitiesSection />
        <HowItWorksSection />
        <FinalCtaSection />
        <SiteFooter />
      </main>
    </div>
  );
}
